import React, { FC, FormEvent, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Form, Grid, Message, Segment } from '../../../ApuKit';
import api from '../../../api';
import { setProfile } from '../../../reducers/auth';
import store from '../../../store';
import styles from './styles.module.scss';

const LoginView: FC<RouteComponentProps> = ({ history }): JSX.Element => {
    const [ error, setError ] = useState<boolean>(false);
    const [ password, setPassword ] = useState<string>('');
    const [ username, setUsername ] = useState<string>('');
    
    const login = (e: FormEvent): void => {
        e.preventDefault();
        
        api.login(username, password).then((profile) => {
            store.dispatch(setProfile(profile));
            history.push('/');
        }).catch(() => {
            setError(true);
        });
    }

    return (<>
        <Grid className={styles.base}>
            <Grid.Row noGutters>
                <Grid.Column sm={6} md={5}>
                    <Segment shadow style={{ height: '100vh' }}>
                        <div className={styles.container}>
                            <div className={styles.logo}>
                                <img src="https://teo.mwit-demo.nl/wp-content/themes/Teo-theme//assets/images/logo.png" alt="" />
                            </div>
                            {error && <Message
                                content="Verkeerde gegevens"
                                error
                                onClose={() => setError(false)}
                            />}
                            <Form onSubmit={(e: FormEvent) => login(e)}>
                                <Form.Input
                                    autoFocus
                                    error={error}
                                    label="Gebruikersnaam"
                                    onChange={({ value }: any) => setUsername(value)}
                                    placeholder="Vul je gebruikersnaam in"
                                    required
                                    value={username}
                                />
                                <Form.Input
                                    error={error}
                                    label="Wachtwoord"
                                    onChange={({ value }: any) => setPassword(value)}
                                    placeholder="Vul je wachtwoord in"
                                    required
                                    type="password"
                                    value={password}
                                />
                                <Button
                                    block
                                    padding="default"
                                    primary
                                    type="submit"
                                >
                                    Inloggen
                                </Button>
                            </Form>
                        </div>
                    </Segment>
                </Grid.Column>
                <Grid.Column
                    className={styles.backgroundImage}
                    isHidden={['xs']}
                    sm={6}
                    md={7}
                />
            </Grid.Row>
        </Grid>
    </>);
}

export default LoginView;
